// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftBox_a[data-v-aa3bf062] .a-form-model-item__label {\n  text-align: right;\n  vertical-align: middle;\n  float: left;\n  font-size: 14px;\n  color: #606266;\n  line-height: 40px;\n  padding: 0 12px 0 0;\n  box-sizing: border-box;\n  line-height: 40px;\n  margin-top: 10px !important;\n}\n.radio-control[data-v-aa3bf062] {\n  font-family: Arial, sans-serif;\n}\n.add-option-row[data-v-aa3bf062] {\n  margin-top: 16px;\n}", ""]);
// Exports
module.exports = exports;
